<div class="wrapper">
  <div class="logo">
    <img loading="lazy" src="/assets/images/logo-light-bg.svg" width="75">
  </div>
  <div class="policies">
    <span>
      <a rel="noopener" href="https://customerhappiness.ketto.org/portal/en/kb/articles/terms-of-use-7-8-2021-1" target="_blank">Term of Use</a> | 
      <a rel="noopener" href="https://customerhappiness.ketto.org/portal/en/kb/articles/privacy-policy-7-8-2021" target="_blank">Privacy Policy</a> | 
      <a rel="noopener" href="/support/use-of-cookies.php" target="_blank">Use of cookies</a>
    </span>
    <div>2023 | All Rights Reserved</div>
  </div>
</div>
